export default {
  title: 'Save Contact and Payment Details',
  form: {
    remember_me: {
      label: 'Create an account for faster checkout on future orders.',
    },
  },
};
